import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const checkOfferEligibilityApi = createApi({
  reducerPath: "checkOfferEligibility",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {
      checkOfferEligibility: builder.query({
        query: () => {
          return {
            url: `/cross-sell/check_offer_eligibility_web/`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const { useLazyCheckOfferEligibilityQuery } = checkOfferEligibilityApi;
export { checkOfferEligibilityApi };
